/**
 * curriculum.json is now stored on S3 in aqua-extended bucket. direct link
 * to Big Idea curriculum folder:
 * https://s3.console.aws.amazon.com/s3/buckets/aqua-extended/gc/whats_the_big_idea/curriculum/?region=us-west-2&tab=overview
 *
 * This file is to store the curriculum when it is fetched and offer hooks to retrieve the fetched curriculum when needed.
 *
 * Current Curriculum is generated in the Big Idea Content Spreadsheet, link to workbook:
 * https://docs.google.com/spreadsheets/d/1VHmXW6dKUbCPMPo3svGKoZo6SSODYqWOOVMNr4RALpc/edit#gid=0
 */
let curriculum = {};

export const getCurriculum = () => curriculum;

export const setCurriculum = (c) => {
  curriculum = c;
};
